import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgCellRendererComponent } from '../../../global/gx-ag-grid/ag-cell-renderer.component';
import { LetDirective } from '@ngrx/component';
import { TypeCellPipe } from './type-cell.pipe';
import { TypeCellLocalStoreService } from './type-cell-local-store.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-type-column',
  imports: [
    LetDirective,
    TypeCellPipe,
    TranslateModule,
  ],
  providers: [TypeCellLocalStoreService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './type-cell.component.html',
  styleUrl: './type-cell.component.scss',
})
export class TypeCellComponent extends AgCellRendererComponent {
  protected readonly viewModel$ = this.localStore.state$;

  constructor(protected override localStore: TypeCellLocalStoreService) {
    super(localStore);
  }
}
